"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sqr601DocumentDefinition = void 0;
const luxon_1 = require("luxon");
const ramda_1 = require("ramda");
const __1 = require("../..");
const sqr601DocumentDefinition = (nhqmembers, newmembers, registry) => {
    const myTest = true;
    const myTitleFontSize = 10;
    const mySmallFontSize = 7;
    function sortNHQName(a, b) {
        const aName = a.member.nameLast + ', ' + a.member.nameFirst;
        const bName = b.member.nameLast + ', ' + b.member.nameFirst;
        return aName.localeCompare(bName);
    }
    function sortProspectiveName(a, b) {
        const aName = a.nameLast + ', ' + a.nameFirst;
        const bName = b.nameLast + ', ' + b.nameFirst;
        return aName.localeCompare(bName);
    }
    const getHFZExpire = (reqs) => ramda_1.pipe(__1.get('HFZRecord'), __1.Maybe.filter(({ IsPassed }) => IsPassed || reqs.CurrentCadetAchv.CadetAchvID < 4), __1.Maybe.map(({ DateTaken, IsPassed }) => [DateTaken.substr(0, 10), IsPassed]), __1.Maybe.map(([s, f]) => [+new Date(s) + 182 * 24 * 60 * 60 * 1000, f]), __1.Maybe.map(([s, f]) => new Date(s).toLocaleDateString('en-US') + (!f ? ' F' : '')), __1.Maybe.orSome(''))(reqs);
    function determineSDA(member, requirements) {
        let req = 0;
        let reqComp = 0;
        let compDate = new Date('01/01/2010').toLocaleDateString('en-US');
        const recentDate = new Date('01/01/2010');
        const reqs = [];
        reqs.push({
            required: requirements.SDAService,
            completionDate: new Date(member.requirements.CurrentCadetAchv.StaffServiceDate),
        });
        reqs.push({
            required: requirements.SDAWriting,
            completionDate: new Date(member.requirements.CurrentCadetAchv.TechnicalWritingAssignmentDate),
        });
        reqs.push({
            required: requirements.SDAPresentation,
            completionDate: new Date(member.requirements.CurrentCadetAchv.OralPresentationDate),
        });
        for (let i = 0; i < 3; i++) {
            if (reqs[i].required) {
                req++;
                if (reqs[i].completionDate.getTime() > recentDate.getTime()) {
                    reqComp++;
                    if (reqs[i].completionDate.getTime() > new Date(compDate).getTime()) {
                        compDate = new Date(reqs[i].completionDate).toLocaleDateString('en-US');
                    }
                }
            }
        }
        if (req === 0) {
            return 'N/A';
        }
        else if (req > reqComp) {
            return '';
        }
        else {
            return compDate;
        }
    }
    const unpoweredFlights = [1, 2, 3, 4, 5];
    const poweredFlights = [6, 7, 8, 9, 10];
    const oflightsShortDescription = (rides) => ([...new Set(rides.map(__1.get('Syllabus')))]
        .reduce(([powered, unpowered], syllabus) => poweredFlights.includes(syllabus)
        ? [powered + 1, unpowered]
        : unpoweredFlights.includes(syllabus)
            ? [powered, unpowered + 1]
            : [powered, unpowered], [0, 0])
        .join('p | ') + 'u')
        .replace('0p', '_p')
        .replace('0u', '_u');
    const fullMembers = myTest
        ? nhqmembers.sort(sortNHQName).map((loopmember) => [
            {
                text: __1.CadetPromotionRequirementsMap[loopmember.requirements.CurrentCadetGradeID]
                    .Grade,
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.member.nameLast + ', ' + loopmember.member.nameFirst,
                fontSize: mySmallFontSize,
                bold: false,
                decoration: new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                    new Date().getTime() <=
                    0
                    ? 'lineThrough'
                    : '',
                alignment: 'left',
            },
            {
                text: loopmember.member.id,
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.member.flight,
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                    new Date().getTime() <=
                    0
                    ? 'Y'
                    : new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                        new Date().getTime() <=
                        60 * 60 * 24 * 30 * 1000
                        ? '<'
                        : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: __1.Maybe.isSome(loopmember.requirements.LastAprvDate)
                    ? loopmember.requirements.LastAprvDate.value -
                        new Date('01/01/2010').getTime() >
                        0
                        ?
                            new Date(loopmember.requirements.LastAprvDate.value +
                                60 * 60 * 24 * 57 * 1000).toLocaleDateString('en-US')
                        : Math.round(Math.round(new Date().getTime() -
                            new Date(loopmember.member.joined).getTime()) /
                            (1000 * 60 * 60 * 24 * 7))
                    : Math.round(Math.round(new Date().getTime() -
                        new Date(loopmember.member.joined).getTime()) /
                        (1000 * 60 * 60 * 24 * 7)),
                fontSize: mySmallFontSize,
                bold: __1.Maybe.isSome(loopmember.requirements.LastAprvDate)
                    ? new Date(loopmember.requirements.LastAprvDate.value +
                        60 * 60 * 24 * 57 * 1000).getTime() -
                        new Date().getTime() <=
                        0
                        ? false
                        : true
                    : false,
                alignment: 'left',
            },
            {
                text: __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetGradeID]
                    .Grade,
                fontSize: mySmallFontSize,
                bold: false,
                alighment: 'left',
            },
            {
                text: loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .Leadership === 'None'
                        ? 'N/A'
                        : ''
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.LeadLabDateP).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .Leadership === 'None'
                                ? 'N/A'
                                : ''
                            : new Date(loopmember.requirements.CurrentCadetAchv.LeadLabDateP.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US'),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .Aerospace === 'None'
                        ? 'N/A'
                        : ''
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.AEDateP).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .Aerospace === 'None'
                                ? 'N/A'
                                : ''
                            : new Date(loopmember.requirements.CurrentCadetAchv.AEDateP.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US'),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .SDAPresentation === false &&
                        __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .SDAService === false &&
                        __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .SDAWriting === false
                        ? 'N/A'
                        : ''
                    :
                        __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .SDAPresentation === false &&
                            __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .SDAService === false &&
                            __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .SDAWriting === false
                            ? 'N/A'
                            : determineSDA(loopmember, __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: getHFZExpire(loopmember.requirements),
                fontSize: mySmallFontSize,
                bold: getHFZExpire(loopmember.requirements) !== ''
                    ? getHFZExpire(loopmember.requirements).charAt(getHFZExpire(loopmember.requirements).length - 1) === 'F'
                        ? new Date(getHFZExpire(loopmember.requirements).substring(0, getHFZExpire(loopmember.requirements).length - 2)).getTime() -
                            new Date().getTime() <=
                            0
                            ? true
                            : false
                        : new Date(getHFZExpire(loopmember.requirements)).getTime() -
                            new Date().getTime() <=
                            0
                            ? true
                            : false
                    : false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .Drill === 'None'
                        ? 'N/A'
                        : __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID].Drill
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.DrillDate).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .Drill === 'None'
                                ? 'N/A'
                                : __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID].Drill
                            : new Date(loopmember.requirements.CurrentCadetAchv.DrillDate.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US'),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .CharDev === false
                        ? 'N/A'
                        : ''
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.MoralLDateP).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .CharDev === false
                                ? 'N/A'
                                : ''
                            : new Date(loopmember.requirements.CurrentCadetAchv.MoralLDateP.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US'),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.CurrentCadetAchv.CadetOath ? 'Y' : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.CurrentCadetAchv.CadetOath ? 'Y' : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.CurrentCadetAchv.CadetOath ? 'Y' : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.requirements.CurrentCadetAchv.CadetOath ? 'Y' : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: __1.Maybe.isSome(loopmember.requirements.ges) ? 'Y' : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: oflightsShortDescription(loopmember.requirements.oflights),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
        ])
        : [];
    const prospectiveMembers = myTest
        ? newmembers
            .sort(sortProspectiveName)
            .filter(mem => mem.seniorMember === false)
            .map((loopmember) => [
            {
                text: loopmember.nameLast + ', ' + loopmember.nameFirst,
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: loopmember.hasNHQReference ? 'Y' : 'N',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
        ])
        : [];
    const nowDate = luxon_1.DateTime.utc();
    const docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'landscape',
        pageMargins: [25, 40, 64, 40],
        header: {
            text: registry.Website.Name +
                ' Cadet Status Report: ' +
                nhqmembers.length.toString() +
                ' members',
            alignment: 'left',
            fontSize: myTitleFontSize,
            bold: true,
            margin: [30, 20, 40, 35],
        },
        footer: (currentPage, pageCount) => {
            var _a;
            return [
                {
                    layout: 'noBorders',
                    table: {
                        widths: [792 - 72],
                        headerRows: 0,
                        body: [
                            [
                                {
                                    layout: 'noBorders',
                                    table: {
                                        widths: ['*', 306, '*'],
                                        headerRows: 0,
                                        body: [
                                            [
                                                {
                                                    text: 'Squadron Report 60-1 Sep 2021',
                                                    bold: true,
                                                    fontSize: mySmallFontSize,
                                                },
                                                {
                                                    text: `Generated by Event Manager on ${(_a = nowDate.toLocaleString({
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                    })) !== null && _a !== void 0 ? _a : ''}`,
                                                    bold: false,
                                                    fontSize: mySmallFontSize,
                                                    alignment: 'center',
                                                },
                                                {
                                                    text: `Page ${currentPage} of ${pageCount}`,
                                                    bold: false,
                                                    fontSize: mySmallFontSize,
                                                    alignment: 'right',
                                                },
                                            ],
                                        ],
                                    },
                                },
                            ],
                        ],
                    },
                    margin: [30, 0, 0, 60],
                },
            ];
        },
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: [
                        29,
                        73,
                        24,
                        25,
                        13,
                        36,
                        29,
                        36,
                        36,
                        36,
                        40,
                        36,
                        36,
                        17,
                        17,
                        17,
                        17,
                        15,
                        33,
                    ],
                    body: [
                        [
                            {
                                text: 'Current Grade',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Full Name',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'CAPID',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Flight',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Exp',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Eligible or Weeks',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Next Grade',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'LeadLab',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'AeroEd',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'SDA/ CI-CWC',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'HFZ Cred Expiration',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Drill Test',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'CharDev/ Wingman',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'AP',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Oath',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'Uni',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'LE',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'GES',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'O-Flights',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                        ],
                        ...fullMembers,
                    ],
                },
                layout: {
                    fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
                },
            },
            {
                text: ' ',
                alignment: 'left',
                fontSize: mySmallFontSize,
                bold: true,
            },
            {
                text: 'Prospective Members',
                alignment: 'left',
                fontSize: myTitleFontSize,
                bold: true,
            },
            {
                table: {
                    headerRows: 1,
                    widths: [
                        73,
                        70,
                    ],
                    body: [
                        [
                            {
                                text: 'Full Name',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                            {
                                text: 'NHQ Association?',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'left',
                            },
                        ],
                        ...prospectiveMembers,
                    ],
                },
                layout: {
                    fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
                },
            },
        ],
        defaultStyle: {
            font: 'FreeSans',
        },
    };
    return docDefinition;
};
exports.sqr601DocumentDefinition = sqr601DocumentDefinition;
//# sourceMappingURL=sqr601.js.map